import { FeatureFlags } from "./LaunchDarkly";
import { z } from "zod";
import { pathKeys } from "../constants/pathnames";

const zodEnum = <T extends unknown>(arr: readonly T[]): [T, ...T[]] =>
  arr as [T, ...T[]];

export const { useFeatureFlag, FeatureFlagsProvider } = FeatureFlags.withSchema(
  {
    "enhanced-error-feedback": z.boolean(),
    "free-text-other-insurance-option": z.boolean(),
    "intercom-everywhere": z.boolean(),
    "miscarriage-book-now-alert": z.boolean(),
    "sign-up-to-circles-prompt": z.boolean(),
    "migrated-pages": z.enum(zodEnum(pathKeys)).array(),
    "upper-west-side-redirect": z.boolean(),
    "hide-nav-links-ct": z.boolean(),
    "show-office-hours": z.boolean(),
  },
)
  .andFallbackValues({
    "enhanced-error-feedback": false,
    "free-text-other-insurance-option": false,
    "intercom-everywhere": true,
    "miscarriage-book-now-alert": false,
    "sign-up-to-circles-prompt": false,
    "migrated-pages": [],
    "upper-west-side-redirect": true,
    "hide-nav-links-ct": true,
    "show-office-hours": true,
  })
  .andLoggers(console.error, console.log);
